import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const SLIDES = [
  {
    tag: "Live now",
    title: ["Every league.", "Every kick."],
    body: "Real fixtures from 40+ competitions — PSL, Premier League, URC, NBA, NFL, NHL, UFC and more.",
    cta: ["/live", "Bet in-play"],
    img: "https://images.unsplash.com/photo-1599158150601-1417ebbaafdd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    tag: "Every minute",
    title: ["Horse racing,", "non-stop."],
    body: "Virtual races at Greyville, Kenilworth, Ascot and Flemington. Win or Place, paid instantly.",
    cta: ["/racing", "Go racing"],
    img: "https://images.unsplash.com/flagged/photo-1569319388901-605a6d2d1299?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    tag: "Lucky Numbers",
    title: ["SA Lotto to", "Powerball."],
    body: "Pick 1–5 numbers on 12 lotteries worldwide, from UK 49's to EuroMillions.",
    cta: ["/lotto", "Pick numbers"],
    img: "https://images.unsplash.com/photo-1518688248740-7c31f1a945c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
  {
    tag: "Multi boost",
    title: ["Up to 30%", "extra winnings."],
    body: "Add 3+ selections to a multi and we boost your winnings — 5%, 10%, 20% or 30%.",
    cta: ["/sport/soccer", "Build a multi"],
    img: "https://images.unsplash.com/photo-1767190937750-d6aaf8ea99d0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
];

export const PromoCarousel = ({ liveCount }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((x) => (x + 1) % SLIDES.length), 6000);
    return () => clearInterval(t);
  }, []);
  const s = SLIDES[i];
  return (
    <section data-testid="promo-carousel" className="grain relative h-[300px] overflow-hidden rounded-xl border border-[#1E293B] sm:h-[320px]">
      {SLIDES.map((sl, k) => (
        <img key={k} src={sl.img} alt="" className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ${k === i ? "opacity-40" : "opacity-0"}`} />
      ))}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B0E14] via-[#0B0E14]/80 to-transparent" />
      <div key={i} className="rise-in relative max-w-xl space-y-3 p-6 sm:p-10">
        <span className="inline-flex items-center gap-2 rounded-full bg-[#EF4444]/15 px-3 py-1 text-xs font-bold uppercase tracking-wider text-[#EF4444]">
          <span className="live-dot h-1.5 w-1.5 rounded-full bg-[#EF4444]" /> {i === 0 ? `${liveCount} matches live now` : s.tag}
        </span>
        <h1 className="font-display text-4xl font-black uppercase leading-[0.9] tracking-tight sm:text-5xl lg:text-6xl">
          {s.title[0]} <span className="text-[#10B981]">{s.title[1]}</span>
        </h1>
        <p className="text-sm text-slate-300 sm:text-base">{s.body}</p>
        <Link to={s.cta[0]} data-testid={`promo-cta-${i}`} className="inline-flex items-center gap-2 rounded-full bg-[#10B981] px-5 py-2.5 font-display font-black uppercase text-[#0B0E14] transition-transform hover:translate-x-1">
          {s.cta[1]} <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
      <div className="absolute bottom-4 right-5 flex gap-1.5">
        {SLIDES.map((_, k) => (
          <button key={k} data-testid={`promo-dot-${k}`} onClick={() => setI(k)} className={`h-1.5 rounded-full transition-[width,background-color] ${k === i ? "w-6 bg-[#10B981]" : "w-1.5 bg-white/40"}`} />
        ))}
      </div>
    </section>
  );
};
